var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import * as StateClasses from '../classes';
import { connect } from 'react-redux';
import MaskedText from 'react-text-mask';
import { saveContact } from '../store/slices/serviceEventSlice';
import { Link, withRouter } from "react-router-dom";
import * as appSliceActions from '../store/slices/AppSlice';
var Contact = /** @class */ (function (_super) {
    __extends(Contact, _super);
    function Contact(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.setState({ contact: __assign({}, _this.props.contactState) });
            _this.props.dispatch(appSliceActions.setTimeLineStep(5));
            console.log('contact mount');
        };
        _this.next = function (e) {
            e.preventDefault();
            _this.props.dispatch(saveContact(__assign({}, _this.state.contact)));
            _this.props.history.push('/activation/confirmation');
        };
        _this.onChange = function (e) {
            var _a;
            _this.setState({ contact: __assign(__assign({}, _this.state.contact), (_a = {}, _a[e.target.name] = e.target.value, _a)) });
        };
        var tmp = new StateClasses.Contact();
        _this.state = {
            contact: __assign({}, tmp)
        };
        return _this;
    }
    Contact.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "contentHolder" },
                React.createElement("h2", null, "What's the best way to reach you on the day of your appointment?"),
                React.createElement("form", { action: "", onSubmit: this.next },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "First Name"),
                            React.createElement("input", { type: "text", maxLength: 50, value: this.state.contact.firstName, name: "firstName", onChange: this.onChange, placeholder: "First", required: true })),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Last Name"),
                            React.createElement("input", { maxLength: 50, value: this.state.contact.lastName, name: "lastName", onChange: this.onChange, placeholder: "Last", required: true, type: "text" }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Email"),
                            React.createElement("input", { maxLength: 50, value: this.state.contact.email, name: "email", onChange: this.onChange, placeholder: "Email", type: "email" }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Telephone"),
                            React.createElement(MaskedText, { mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/], maxLength: 50, value: this.state.contact.phone, name: "phone", onChange: this.onChange, placeholder: "phone", type: "phone" })),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Text Reminders"),
                            React.createElement("select", { value: this.state.contact.textReminder, onChange: this.onChange, name: "textReminder" },
                                React.createElement("option", { value: "Yes" }, "Yes"),
                                React.createElement("option", { value: "No" }, "No")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Special Instructions?"),
                            React.createElement("textarea", { value: this.state.contact.instructions, onChange: this.onChange, name: "instructions", placeholder: "" }))),
                    React.createElement("div", { className: "row-right" },
                        React.createElement(Link, { to: "/activation/schedule" },
                            React.createElement("span", { className: "btn" }, "Back")),
                        React.createElement("button", { type: "submit", value: "Submit" }, "Next"))))));
    };
    return Contact;
}(React.Component));
function mapStateToProps(state) {
    return {
        serviceEventId: state.serviceEvent.serviceEventId,
        contactState: state.serviceEvent.contact
    };
}
export default withRouter(connect(mapStateToProps)(Contact));
